<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    v-if="messages.length"
    :class="['topbar', { 'topbar--cart': isCartPage }]"
  >
    <div class="topbar__container container">
      <div class="topbar__messages">
        <div
          v-for="(message, idx) in messages"
          :key="idx"
          :class="['topbar__message']"
          v-html="message"
        ></div>
      </div>

      <ul class="topbar__nav">
        <li v-if="$isBrStore">
          <a
            href="/go-for-good"
            class="topbar__nav-link"
            aria-label="Go For Good"
          >
            Go For Good
          </a>
        </li>
        <li>
          <a
            :href="helpCenterUrl"
            class="topbar__nav-link"
            target="_blank"
            rel="noopener"
            aria-label="Help Center"
          >
            {{ $t('help_center') }}
          </a>
        </li>
        <li v-if="$isGlobalStore">
          <a
            href="/find-order"
            class="topbar__nav-link"
            rel="noopener"
            aria-label="Track Order"
          >
            {{ $t('track_order') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      helpCenterUrl: this.$isBrStore
        ? 'https://suporte.gocase.com.br/hc/pt-br'
        : 'https://support.shop-gocase.com/hc/en-us',
    }
  },
  computed: {
    ...mapState(['siteStore']),
    messages() {
      // eslint-disable-next-line camelcase
      const messageByCountry = this.siteStore?.localized_global_messages?.[
        this?.$store?.state?.countryCode
      ]

      return (
        messageByCountry ||
        (this.substore.active
          ? this.substore.global_messages
          : // eslint-disable-next-line camelcase
            this.siteStore?.global_messages) ||
        []
      )
    },
    substore() {
      return this.$store.state.substore
    },

    isCartPage() {
      return this.$route.path === '/cart'
    },
  },
  mounted() {
    if (this.messages.length > 1) this.startTopbarAnimation()
  },
  methods: {
    startTopbarAnimation() {
      const defaultHeight = 33
      let currentPosition = 0
      let toTop = true
      setInterval(() => {
        if (toTop) {
          currentPosition -= defaultHeight
        } else {
          currentPosition += defaultHeight
        }

        if (currentPosition === -(this.messages.length - 1) * 33) {
          toTop = false
        }

        if (currentPosition === 0) {
          toTop = true
        }

        this.setCurrentPosition(currentPosition)
      }, 3000)
    },
    setCurrentPosition(currentPosition) {
      document.querySelector(
        '.topbar__messages'
      ).style.transform = `translateY(${currentPosition}px)`
    },
  },
}
</script>

<style lang="scss">
.topbar {
  background-color: $v4_color_primary_lighter;
  color: #626266;
  padding: 0 10px;
  font-size: 12px;
  padding: 6px 0 7px;
  height: 33px;
  overflow: hidden;

  .topbar__container {
    display: flex;
  }

  .topbar__messages {
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: -webkit-transform 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out;
    transition: transform 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
    flex-grow: 1;

    .topbar__message {
      height: 33px;
      margin: 0;
    }

    @media (max-width: $v4_desktop) {
      text-align: center;
    }

    @media (min-width: $v4_desktop) {
      font-size: 14px;
    }

    b,
    strong {
      font-weight: bold;
    }

    a {
      color: #f087be;
      text-decoration: underline;
      font-weight: bold;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .topbar__nav {
    display: none;
  }

  .topbar__nav-link {
    color: $v4_color_blue;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: $v4_desktop) {
  .topbar--cart {
    display: none;
  }
}

@media (min-width: $v4_desktop) {
  .topbar {
    .topbar__nav {
      display: flex;
      font-size: 14px;

      > li {
        position: relative;
        padding-left: 30px;
        margin-left: 24px;

        &:first-child:before {
          display: none;
          padding-left: 0;
        }

        &:before {
          content: '⋮';
          position: absolute;
          left: 0;
          top: -1px;
          color: #fbd4da;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
